"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDefaultEventData = exports.postEvent = exports.configure = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _axiosRetry = _interopRequireDefault(require("axios-retry"));

var _immutable = require("immutable");

var _isRetryAllowed = _interopRequireDefault(require("is-retry-allowed"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Use an instance until we know more about globally configuring this.
// Given my current level of understanding of how JS dependency sharing works,
// I can't be confident when and when not affecting the global defaults might
// be shared with dependencies or clients.
var axiosInstance = _axios["default"].create({
  transitional: {
    clarifyTimeoutError: true
  }
});

(0, _axiosRetry["default"])(axiosInstance, {
  retries: 3,
  retryDelay: _axiosRetry["default"].exponentialDelay,
  shouldResetTimeout: true
});
var config = (0, _immutable.Map)({
  'url': '',
  'apiKey': '' // App doesn't use withCredentials, I don't know how to test it or what
  // change it's supposed to make, let's bring it back when/if we need it.
  // 'withCredentials': false

});
var defaultEventData = (0, _immutable.Map)();

var configure = function configure(updatedConfig) {
  config = config.merge(updatedConfig);
};

exports.configure = configure;

var setDefaultEventData = function setDefaultEventData(updatedEventData) {
  defaultEventData = defaultEventData.merge(updatedEventData);
};
/*
  This is identical to axios-retry's `isNetworkError`, with the exception that
  we retry requests that have no error.code

  I'm unsure what having no error.code functionally represents, and haven't been
  able to figure it out in the amount of time worth allocating to this ticket.
  In their `isNetworkError`, axios-retry says about it
  ```
    && Boolean(error.code) // Prevents retrying cancelled requests
  ```
  which may be referring to axios's cancellation ability https://axios-http.com/docs/cancellation
  which we don't use, but I'm unsure.  Axios xhr handling code handles network errors with
  ```
      // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };
  ```
  which is explicitly passing `null` as the `code` to `creaeteError`.  So...network
  errors should always have no code.  So maybe they are saying "let's not retry
  on networks errors because who knows if the data made it to the server"?

  Either way, these network errors are annoying, seemingly likely legitimate
  (API Gateway has a page specifically about "what if i get a ton of network errors",
  where they say "eh, just retry"), and insights prefers duplicates to missed events,
  so LFG.  With luck, this will solve the issue of App getting spammed by network
  errors.  Without luck, this is some kind of CORS or browser-based URL blocking issue
  that will take more work to address.
*/


exports.setDefaultEventData = setDefaultEventData;

function isNetworkError(error) {
  return (// if there's no response, we got nothing back from the server.  indicates
    // a network issue, though i believe we can't be sure that the request
    // didn't make it to the server.
    !error.response // This is the additional line that axios-retry has, but is causing us issues
    // I'm not sure why the added it and didn't find anything from digging through
    // their commit history.  They say it " Prevents retrying cancelled requests",
    // but we appear to be seeing it on most of our insights request errors
    // && !!error.code
    // Prevents retrying timed out requests, according to axios-retry
    && error.code !== 'ECONNABORTED' // Prevents retrying unsafe errors (lots of SSL issues, ENOTFOUND, ENETUNREACH)
    && (0, _isRetryAllowed["default"])(error)
  );
}

var postEvent = function postEvent(eventData) {
  var url = config.get('url');
  var apiKey = config.get('apiKey'); // const withCredentials = config.get('withCredentials');

  var data = defaultEventData.merge(eventData).toObject();
  if (!url || !apiKey) throw new Error('Insights url and apiKey must be configured before calling postEvent');
  return axiosInstance.post(url, data, {
    'headers': {
      'Content-Type': 'application/json',
      'X-Api-Key': apiKey
    },
    'axios-retry': {
      retryCondition: function retryCondition(error) {
        return isNetworkError(error);
      }
    } // 'withCredentials': withCredentials

  });
};

exports.postEvent = postEvent;